import { components } from '../../../generated'
import { TranslationDictionary } from '../../../utils'

export const COUNT_NEW_NOTIFICATIONS_KEY = 'countNewNotifications'

export const NOTIFICATIONS_SETTINGS_KEY = 'notificationsSettings'

export const NOTIFICATIONS_KEY = 'notifications'

export enum NOTIFICATIONS_SERVICE_TYPE {
  OFFICE = 'office',
  JOB = 'job',
  SHOP = 'shop',
  BLOG = 'blog'
}

export enum NOTIFICATION_SETTINGS_VARIANT {
  DISABLED = 'disabled',
  ALL = 'all',
  INTERNAL = 'internal',
  EMAIL = 'email',
  CUSTOM = 'custom'
}

export enum NOTIFICATIONS_SETTINGS_JOB_CATEGORY_VARIANT {
  FEEDBACKS_AND_MESSAGES = 'feedbacks-and-messages',
  LIKES_PROJECTS = 'likes-projects',
  RECOMMENDED_TENDERS = 'recommend-tenders',
  VERIFY_STATUS = 'verify-status',
  PACKET_EXPIRATION_DATE = 'packet-expiration-date'
}

//export const NOTIFICATION_SERVICES_TYPE = {

export const getNotificationServicesType = (
  translate: TranslationDictionary['data']
) => {
  return {
    [NOTIFICATIONS_SERVICE_TYPE.OFFICE]:
      translate?.['notifications']['short-office'] ??
      'notifications.short-office',
    [NOTIFICATIONS_SERVICE_TYPE.JOB]:
      translate?.['job']['title2'] ?? 'job.title2',
    [NOTIFICATIONS_SERVICE_TYPE.SHOP]:
      translate?.['market']?.['title'] ?? 'market.title'
    // [NOTIFICATIONS_SERVICE_TYPE.BLOG]:
    //   translate?.['blog2']?.['title'] ?? 'blog.title'
  }
}

//export const NOTIFICATION_SERVICES_TYPE_OPTIONS = Object.entries(
export const getNotificationServicesTypeOptions = (
  translate: TranslationDictionary['data']
) => Object.entries(getNotificationServicesType(translate))
//export const NOTIFICATIONS_SETTINGS_SELECT: Record<
export const getNotificationsSettingsSelect: (
  translate: TranslationDictionary['data']
) => Record<components['schemas']['AlertSettingsValues'], string> = (
  translate: TranslationDictionary['data']
) => {
  return {
    [NOTIFICATION_SETTINGS_VARIANT.DISABLED]:
      translate?.['office-site']['settings-page']['disable'],
    [NOTIFICATION_SETTINGS_VARIANT.ALL]:
      translate?.['office-site']['settings-page']['all-notifications'],
    [NOTIFICATION_SETTINGS_VARIANT.INTERNAL]:
      translate?.['office-site']['settings-page']['only-service'],
    [NOTIFICATION_SETTINGS_VARIANT.EMAIL]:
      translate?.['office-site']['settings-page']['only-email']
  }
}
//export const NOTIFICATIONS_SETTINGS_SELECT_OPTIONS = Object.entries(
export const getNotificationSelectOptions = (
  translate: TranslationDictionary['data']
) => Object.entries(getNotificationsSettingsSelect(translate))
